import { render, staticRenderFns } from "./Promotional.vue?vue&type=template&id=d6a40c4e&"
import script from "./Promotional.vue?vue&type=script&lang=js&"
export * from "./Promotional.vue?vue&type=script&lang=js&"
import style0 from "./Promotional.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports